// @flow

import typeToReducer from 'type-to-reducer'

import type { Limits } from '@alphaott/api-client/types/limits'

import { GET_RADIO_CHANNEL_LIMITS, RESET_RADIO_CHANNEL_LIMITS } from '../../actions'

export type RadioChannelLimitState = {
  +isLoading: boolean,
  +isSuccess: boolean,
  +isError: boolean,
  +errors: any,
  +data: Limits | {},
}

const initialState: RadioChannelLimitState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  errors: [],
  data: {},
}

const radioChannelLimits = typeToReducer(
  {
    [GET_RADIO_CHANNEL_LIMITS]: {
      LOADING: (state): RadioChannelLimitState => ({ ...state, isLoading: true }),

      SUCCESS: (state, action): RadioChannelLimitState => ({
        ...state,
        isLoading: false,
        isSuccess: true,
        data: action.payload.data,
      }),

      ERROR: (state, action): RadioChannelLimitState => ({
        ...state,
        isLoading: false,
        isSuccess: false,
        isError: true,
        errors: action.payload.error,
      }),
    },
    [RESET_RADIO_CHANNEL_LIMITS]: () => initialState,
  },
  initialState,
)

export { radioChannelLimits }
